import * as Styled from './OxTextTagline.styled';

import React, { PropsWithChildren } from 'react';

type TProps = PropsWithChildren<unknown>;

export const OxTextTagline = ({ children }: TProps): JSX.Element => {
    return <Styled.Tagline>{children}</Styled.Tagline>;
};
